import { render } from "./sysStatus.vue?vue&type=template&id=121d7691&scoped=true"
import script from "./sysStatus.vue?vue&type=script&lang=js"
export * from "./sysStatus.vue?vue&type=script&lang=js"

import "./sysStatus.vue?vue&type=style&index=0&id=121d7691&scoped=true&lang=css"

import exportComponent from "D:\\zhang\\项目\\经皮黄疸仪\\jaundiceweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121d7691"]])

export default __exports__